<template>
  <LandingPage />
  <AboutUsLanding />
  <ServicesLanding />
  <OurProjectsLanding />
  <WhereWeWork />
  <!-- <ReferralsLanding /> -->
  <DevelopmentProcess />
  <WhyChooseUs />
  <CTASection />
  <FAQ :limit-questions="7" />
  <ClientOnly>
    <ContactForm />
  </ClientOnly>

  <!--
  <Work />
  <Approach />
  <Technologies />

  <ClientOnly>
    <SubscriptionBox />
  </ClientOnly> -->
</template>

<script lang="ts" setup>
useSeo({
  title: "VORTEC | Build What's Next.",
  description:
    'VORTEC is a software development & design studio building bespoke web experiences, scalable applications and intuitive interfaces. From startups to enterprises — we build what’s next.',
  path: '/',
  jsonLd: {
    '@type': 'WebPage',
    name: "VORTEC | Build What's Next.",
    description: 'Custom web development, UI/UX design and scalable software for ambitious brands.',
    url: 'https://vortec.io',
    isPartOf: { '@type': 'WebSite', name: 'VORTEC', url: 'https://vortec.io' },
  },
});
</script>
